/* eslint-disable */
module.exports = {
	hideGuides: true,
	displayBlogPreviewImages: false,
	googleSiteVerification: "tFT9lOPF-n9pk5w2SAabmCdG2XKYBlmChnofZqGi3bs",
	email: "mail@andrewgriffithsonline.com",
	siteUrl: "https://andrewgriffithsonline.com",
	social: {
		twitter: "https://twitter.com/agriffonline",
		github: "https://github.com/techjacker",
		medium: "https://medium.com/@andrewgriffiths",
		linkedin: "http://uk.linkedin.com/in/andrewgriffithsonline"
	},
	title: "Andrew Griffiths",
	description:
		"Independent technology consultant helping companies build and scale using serverless technology.",
	about: [
		"I am an independent consultant expert in AWS, Google Cloud & Azure serverless cloud technology.",
		"I specialise in helping companies build faster, scale and reduce infrastructure costs.",
		// "I specialise in serverless technology.",

		"I have 10+ years full stack JavaScript, Python and Golang experience building and deploying web and mobile applications."
		// "I help companies migrate to and build highly scalable infrastructure .",
		// "I specialise in developing applications using serverless technology. I help companies build new products quickly and provide consultancy on how to optimise their current infrastructure."
		// "I specialise in developing applications using serverless technology. I help companies build new products quickly and provide consultancy on how to optimise their current infrastructure."

		// "I build applications that scale to millions of users. I am able to do this by selecting the best tools from my 10+ years' experience of full stack web development.",
		// "I am ",
		// "Andrew Griffiths specialises in developing rapid prototypes for startups and companies launching new products.",
		// "Drop me a line to discuss your project."
		// "Expert at building and deploying applications in Golang, Python and JavaScript using serverless platforms.",
		// "Currently building the next generation of blockchain applications on bitcoin's lightning network.",
		// "Available to hire for consultancy and development."
	],
	metaTags: [
		{
			page: "home",
			title: "Andrew Griffiths | Software Developer",
			description:
				"Independent consultant helping companies build and scale using serverless technology.",
			keywords:
				"serverless consultant, serverless expert, aws lambda consultant"
		},
		{
			page: "about",
			title: "About",
			description:
				"Independent consultant helping companies build and scale using serverless technology.",
			keywords:
				"serverless consultant, serverless expert, aws lambda consultant"
		},
		{
			page: "training",
			title: "Serverless Training Workshops",
			description:
				"Expert in person training workshops to help your organisation master serverless technology.",
			keywords:
				"serverless training, serverless workshops, aws serverless training, aws lambda training"
		}
	]
};



// WEBPACK FOOTER //
// ./config.js